import { useState } from 'react'

// Adapted from https://usehooks.com/useLocalStorage/

// Note that initialValue is _not_ saved to session storage — it is an
// optional parameter that you can pass when you need to apply some initial
// value that will be subsequently changed. See implementation in
// tasks/openEndedQuestions/Question.js TextArea, where the provided
// initialValue is a value from Context; when the TextArea input is
// changed, _that_ value is written to session storage. You can think of
// initialValue as an optional starting point for data that will eventually
// be written to session storage, but do not rely on it to be persistent
// all on its own. -CP
export default function useSessionStorage(key, initialValue = '') {
  // Use lazy initial state by passing function to useState;
  // it is only called on the initial component render
  const [storedValue, setStoredValue] = useState(() => {
    const item = sessionStorage.getItem(key)
    return item ? JSON.parse(item) : initialValue
  })

  // We need to return a wrapped version of setStoredValue
  // which writes the value to store into session storage
  function setValue(value) {
    const valueToStore = value instanceof Function ? value(storedValue) : value
    setStoredValue(valueToStore)
    sessionStorage.setItem(key, JSON.stringify(valueToStore))
  }

  return [storedValue, setValue]
}
